import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import LoginComponent from '../../../Components/UserComponents/Login';
import {getAllApprovedAds, getAllApprovedJobs} from '../../../Store/Actions';
import { getPbssInternationalById } from '../../../Store/Actions/pbssInternational';

const LoginContainer = () => {
  let dispatch = useDispatch();
  const {getApprovedJobs} = useSelector(({jobs}) => jobs);
  const {getApprovedAds} = useSelector(({ads}) => ads);
  const [allApprovedJobsData, setAllApprovedJobsData] = useState([]);
  const [allApprovedAdsData, setAllApprovedAdsData] = useState([]);
  const {allPbssInternational} = useSelector(
    ({pbssInternational}) => pbssInternational,
  );
const [pbssInternationalData, setPbssInternationalData] = useState();

  useEffect(() => {
    if (getApprovedJobs) {
      const Data = getApprovedJobs?.data?.jobs.slice(0, 3);
      setAllApprovedJobsData(Data);
    } else {
      dispatch(getAllApprovedJobs());
    }
  }, [getApprovedJobs]);

  useEffect(() => {
    if (getApprovedAds) {
      const Data = getApprovedAds?.data?.ads.slice(0, 3);
      setAllApprovedAdsData(Data);
    } else {
      dispatch(getAllApprovedAds());
    }
  }, [getApprovedAds]);

  useEffect(() => {
    if (
      allPbssInternational &&
      allPbssInternational?.data?.pbssInternational &&
      allPbssInternational?.data?.pbssInternational.length > 0
    ) {
      setPbssInternationalData(allPbssInternational?.data?.pbssInternational[0]);
    }
  }, [allPbssInternational]);

  useEffect(() => {
    fetchPbssInternationalById();
  }, []);

  const fetchPbssInternationalById = () => {
    dispatch(getPbssInternationalById());
  };

  return (
    <LoginComponent
      allApprovedJobsData={allApprovedJobsData}
      allApprovedAdsData={allApprovedAdsData}
      pbssInternationalData={pbssInternationalData}
    />
  );
};

export default LoginContainer;
